import { fetchItems } from "../../utils/fetchItemData";
import { useState, useEffect } from "react";
import CustomTabs from "../../components/ui/CustomTabs";
import { useParams, useNavigate } from "react-router-dom";
import EnergyItems from "../../components/energyComponents/energyItems";
import EnergyOther from "../../components/energyComponents/energyOther";

const Energy = () => {
  const [energyItems, setEnergyItems] = useState(null);
  const { tab } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(tab || "items");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchItems({
      itemId: null,
      setItems: (fetchedItems) => {
        const filtered = fetchedItems
          .filter((item) => item.energyGiven > 50)
          .sort((a, b) => b.energyGiven - a.energyGiven)
          .map((item) => ({
            value: item.id,
            label: item.name,
            energyValue: item.energyGiven,
            image: item.image,
            data: item,
          }));
  
        setEnergyItems(filtered);
        setLoading(false);
      },
    });
  }, []);  

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    }
  }, [tab]);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    navigate(`/tools/energy/${tabKey}`);
  };

  const energyTabs = [
    { key: "items", label: "Energy Items", component: <EnergyItems items={energyItems} /> },
    { key: "other", label: "Other", component: <EnergyOther /> },
  ];

  return (
    <div className="panel-style">
      <h2 className="panel-heading">Energy</h2>
      {loading ? (
        <div className="p-8 text-center">Loading...</div>
      ) : energyItems ? (
        <CustomTabs tabs={energyTabs} activeTab={activeTab} onTabChange={handleTabChange} />
      ) : (
        <div className="p-8 text-center">No energy data found</div>
      )}
    </div>
  );
};

export default Energy;
